import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminMenu: [],
    topActiveId: 0,
    leftTitle: "",
    order:[],
    serve:'https://www.bioflin.com:83'
    //serve:'http://api.yelibio.cn'
    //serve:'http://lineapi.bioflin.com'
  },
  mutations: {
    changeMenu(state, v) {
      state.adminMenu = v;
    },
    topActiveId(state, w) {
      state.topActiveId = w
    },
  },
  actions: {
    
  }
})